
const upperGiSymptoms=[
{symptom:"appetiteLoss",
displayAs:"Appetite Loss",
questionGroup:"duration"
},

{symptom:"earlySatiety",
displayAs:"Early Satiety / feeling full",
questionGroup:"duration"
},

{symptom:"nausea",
displayAs:"Nausea",
questionGroup:"duration"},

{symptom:"vomiting",
displayAs:"Vomiting",
questionGroup:"duration"},

{symptom:"reflux",
displayAs:"Reflux",
questionGroup:"duration"
},

{symptom:"dysphagia",
displayAs:"Dysphagia",
questionGroup: "dysphagia"},

{symptom:"dyspepsia",
displayAs:"Dyspepsia",
questionGroup: "dyspepsia"},

{symptom:"haematemesis",
displayAs:"Haematemesis",
questionGroup: "haematemesis",
},

]

export default upperGiSymptoms